module.exports = __webpack_public_path__ + "img/promotoresPeople.439d4c94.svg";